<template>
  <icon-base
    :title="title"
    :name="name"
    :viewbox="viewBox">
    



<g>
	<path d="M12.413,15.763c-0.209,0-0.356-0.007-0.429-0.011c-0.073,0.005-0.22,0.011-0.429,0.011c-1.019,0-3.567-0.178-5.224-1.832
		c-1.996-1.992-1.849-5.247-1.82-5.678V5.277c0-0.414,0.336-0.75,0.75-0.75s0.75,0.336,0.75,0.75v2.245
		c0.79,0.026,1.96,0.159,3.094,0.639c-0.081-0.344-0.122-0.685-0.122-1.02c0-2.116,1.588-3.835,2.25-4.46V0.766
		c0-0.414,0.336-0.75,0.75-0.75c0.413,0,0.75,0.336,0.75,0.75v1.915c0.662,0.625,2.25,2.345,2.25,4.46
		c0,0.335-0.041,0.676-0.122,1.021c1.134-0.481,2.305-0.613,3.095-0.64V5.277c0-0.414,0.336-0.75,0.75-0.75s0.75,0.336,0.75,0.75
		v2.978c0.029,0.431,0.173,3.685-1.82,5.676C15.981,15.584,13.432,15.763,12.413,15.763z M12.739,14.252
		c0.989-0.043,2.736-0.283,3.837-1.383c1.106-1.105,1.345-2.85,1.385-3.841c-0.997,0.046-2.754,0.292-3.844,1.382
		c-1.091,1.091-1.333,2.823-1.38,3.77C12.738,14.205,12.738,14.229,12.739,14.252z M6.008,9.026c0.041,0.991,0.279,2.74,1.384,3.843
		c1.099,1.097,2.85,1.339,3.838,1.383c0.001-0.021,0.001-0.042,0.002-0.063c-0.047-0.95-0.29-2.689-1.38-3.779
		C8.745,9.305,6.988,9.067,6.008,9.026z M11.984,4.055c-0.591,0.627-1.5,1.8-1.5,3.086c0,1.29,0.908,2.461,1.499,3.087
		c0.591-0.627,1.501-1.801,1.501-3.087C13.484,5.855,12.575,4.682,11.984,4.055z"/>
	<path d="M11.984,24c-0.414,0-0.75-0.336-0.75-0.75v-0.743c-1.163-0.04-3.4-0.326-4.902-1.826c-2.077-2.073-1.829-5.562-1.818-5.709
		c0.029-0.37,0.319-0.66,0.689-0.689c0.017-0.001,0.194-0.016,0.49-0.016c1.017,0,3.563,0.179,5.219,1.833
		c0.43,0.43,0.789,0.947,1.072,1.545c0.284-0.598,0.643-1.115,1.072-1.545c1.655-1.655,4.201-1.833,5.219-1.833
		c0.294,0,0.473,0.014,0.492,0.016c0.368,0.029,0.658,0.319,0.687,0.689c0.012,0.147,0.259,3.635-1.817,5.709
		c-1.503,1.5-3.74,1.786-4.903,1.826v0.743C12.734,23.663,12.397,24,11.984,24z M12.739,21.002c0.989-0.043,2.736-0.283,3.837-1.383
		c1.104-1.103,1.343-2.851,1.384-3.843c-0.98,0.041-2.737,0.278-3.844,1.384c-1.091,1.091-1.333,2.823-1.38,3.77
		C12.738,20.955,12.738,20.979,12.739,21.002z M6.008,15.775c0.04,0.991,0.279,2.741,1.384,3.844
		c1.094,1.092,2.848,1.336,3.838,1.382c0.001-0.02,0.001-0.041,0.002-0.062c-0.047-0.951-0.29-2.689-1.38-3.779
		C8.74,16.049,6.98,15.814,6.008,15.775z"/>
</g>


  </icon-base>
</template>

<script>
import IconBase from '../IconBase';

export default {
  components: {
    IconBase,
  },
  props: {
    title: {
      type: String,
      required: false,
      default: 'farming-wheat',
    },
    name: {
      type: String,
      required: false,
      default: 'FarmingWheat',
    },
    viewBox: {
      type: String,
      required: false,
      default: '0 0 24 24',
    },
  },
};
</script>

<style scoped>
  
</style>